// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export * from './featureStore';

export interface Instance { [key: string]: string | number }
